import { OidcConfiguration } from "@axa-fr/react-oidc";

const oidcConfiguration: OidcConfiguration = {
  client_id: "consorcio-autocompra-web",
  redirect_uri: `${window.location.origin}/authentication/callback`,
  scope: "openid profile email",
  authority: `${window.env.REACT_APP_AUTH_URL}/auth/realms/person`,
  refresh_time_before_tokens_expiration_in_second: 120,
};

export default oidcConfiguration;
